module.exports = __webpack_public_path__ + "img/loading.21001161.svg";